import { convertISOToDateFormat } from '../../../../util/timezone';

// genarateTableConfigs hands custom renderers `value || '-'`, so an empty date arrives
// as '-'. Short-circuit it instead of parsing it: the output is the same '-', without
// moment's non-ISO fallback warning (FIN-13885 reuses these renderers on FRAML View).
const date = (text) =>
  text && text !== '-' ? convertISOToDateFormat(text) : '-';

export default {
  defaultProperties: {
    render: (text) => (text ? text : '-')
  },
  customProperties: {
    anticipatedSettlementDate: { render: date },
    accountClosedDate: { render: date },
    lastPaymentDate: { render: date },
    loanFirstDisbursementDate: { render: date },
    nextInstallmentDate: { render: date },
    accountOpenDate: { render: date }
  }
};
